import { Button, Drawer, Form, message } from 'antd'
import React, { useEffect } from 'react'
import useBoolean from '../../../../Utils/useBoolean';
import { useDispatch, useSelector } from 'react-redux';
import { addCompaniesInfo, addInvoiceToInfo, changeCompaniesInfo, changeInvoiceToInfo, fetchCompaniesInfo, fetchInvoiceParams } from '../../../../Reducers/balance';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import FormItem from '../../../PrintInvoiceForm/FillShippingForm/FormItem';
import useUpdateCustomerSettings from '../../../../Utils/useUpdateCustomerSettings';

const CreateInvoiceToDrawer = ({ payload, companyId, companyPayload, setCompany }) => {
  const updateCustomerSettings = useUpdateCustomerSettings();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { value: isOpen, setFalse: close, setTrue: open } = useBoolean(false);

  const companyData = companyPayload?.find(company => company.id === companyId);

  // console.log(`companyData: ${JSON.stringify(companyData)}`)

  // console.log(`TYPE PROPS: ${typeof updateCustomerSettings}`); 

  const openToCreateNewCompany = () => {
    setCompany(null)
    form.resetFields();
    open();
  }

  useEffect(() => {
    if (companyData) {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        ...companyData,
      });
    } else {
      form.resetFields();
    }
  }, [companyId, companyData, form]);

  const handleEditCompany = (data) => {

    const updatedInvoiceTo = [...(companyPayload || [])];

    const id = companyId ? companyId :
      (updatedInvoiceTo.length > 0 
        ? Math.max(...updatedInvoiceTo.map(c => c.id || 0)) + 1 
        : 1);

    const formData = {
        id,
        toName: data.toName,
        toLine1: data.toLine1,
        toLine2: data.toLine2,
        toLine3: data.toLine3,
        docNumber: data.docNumber
    };

   
    const index = updatedInvoiceTo.findIndex((c) => c.id === companyId);

    if (index > -1) {
      updatedInvoiceTo[index] = formData; // Update existing company
    } else {
      updatedInvoiceTo.push(formData); // Add new company
    }

    // console.log(`PAYLOAD: ${JSON.stringify(updatedInvoiceTo)}`)

    updateCustomerSettings({ invoiceTo: updatedInvoiceTo });
    close();

    // const formData = {
    //   ...(companyId ? { id: companyId } : {}),
    //     toName: data.toName,
    //     toLine1: data.toLine1,
    //     toLine2: data.toLine2,
    //     toLine3: data.toLine3,
    // };

    // const request = companyId ? changeInvoiceToInfo : addInvoiceToInfo
    // dispatch(request(formData))
    //   .then(() => {
    //     message.success(`Successfully ${companyId ? 'edited' : 'created'} company!`);
    //     dispatch(fetchInvoiceParams())
    //     close();
    //   })
    //   .catch((err) => {
    //     message.error(`Failed to ${companyId ? 'edit' : 'create'} company: ${err}`);
    //   });
  };

  return (
    <div>
      <div className="company_btns">
        {companyId && <Button className="company_btns__btn" onClick={open} icon={<EditOutlined />} />}
        {!companyId && <Button className="company_btns__btn" onClick={openToCreateNewCompany} icon={<PlusOutlined />}>Add company</Button>}
      </div>
      
      <Drawer
        visible={isOpen}
        title={companyId ? "Edit Company" : "Create Company"}
        closable
        onClose={close}
        width={800}
        placement="right"
      >
        <Form form={form} onFinish={handleEditCompany}>
          <FormItem title="Company name" attribute="toName" placeholder="Company name" />
          <FormItem title="Address line 1" attribute="toLine1" placeholder="Address line 1" />
          <FormItem title="Address line 2" attribute="toLine2" placeholder="Address line 2" />
          <FormItem title="Address line 3" attribute="toLine3" placeholder="Address line 3" />
          <FormItem title="Invoice Number" attribute="docNumber" placeholder="Template invoice number" />
          <Button type="primary" htmlType="submit">
            {companyId ? "Save Changes" : "Create Company"}
          </Button>
        </Form>
      </Drawer>
    </div>
  );
};

export default CreateInvoiceToDrawer;
